import customAxios from '../../../utils/customAxios';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalQDelete(props) {
    const {
        questionModalDeleteString,
        questionMDQuestionString,
        questionMDQTypeString,
        questionMDRTypeString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteQuestionText = localStorage.getItem("questionTextToDelete");
    var deleteQuestionType = localStorage.getItem("questionTypeToDelete");
    var deleteResponseType = localStorage.getItem("questionRTypeToDelete");

    var deleteQuestionId = localStorage.getItem("questionIdForDelete");
    
    function deleteQuestion() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteQuestion/${deleteQuestionId}`,
            method: 'delete',
            data: {
                'section_id': props.selectedSection
            },
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar pregunta. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS() {
        props.onHide();
        getToast({ status: 'success', title: 'Pregunta eliminada exitosamente en el cuestionario.' });
        props.getQuestionsData(props.selectedSection);
        props.getDirectoryData();
    }    
    
    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {questionModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{questionMDQuestionString}: </strong>{deleteQuestionText}</span><br />
                <span className='delete-info'><strong>{questionMDQTypeString}: </strong>{deleteQuestionType}</span><br />
                <span className='delete-info'><strong>{questionMDRTypeString}: </strong>{deleteResponseType}</span><br />
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteQuestion()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalQDelete;